export enum AclPermission {
  Admin = 'admin',
  Staff = 'staff',
  Organization = 'organization',
  Project = 'project',
  Task = 'task',
  Environment = 'environment',
}
